import { createFileRoute } from '@tanstack/react-router';
import { JsonBuilder } from '@/components/agents/json-builder';

export const Route = createFileRoute('/_dashboard/agents/create/json')({
  component: JsonBuilderPage,
});

function JsonBuilderPage() {
  return <JsonBuilder />;
}
